import type { RequestParams } from '../requests/http-client';
import { ContentType, HttpClient } from '../requests/http-client';
import type {
  AddTransportEventFilterReq,
  BaseErrorResponse,
  CreateTransportReq,
  Cs2TransportVM,
  UpdateTransportEventFilterReq,
  UpdateTransportReq,
} from './data-contracts';


export default function useTransport() {
  class Transport<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Transport
     * @name TransportEventFilterControllerAddEventFilter
     * @summary Creates a transport event filter
     * @request POST:/cs2/transport/{transportId}/event-filter
     * @secure
     * @response `200` `Cs2TransportVM`
     * @response `400` `BaseErrorResponse`
     */
    transportEventFilterControllerAddEventFilter = (
      transportId: number,
      data: AddTransportEventFilterReq,
      params: RequestParams = {},
    ) =>
      this.request<Cs2TransportVM, BaseErrorResponse>({
        path: `/cs2/transport/${transportId}/event-filter`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Transport
     * @name TransportEventFilterControllerUpdateEventFilter
     * @summary Updates a transport event filter
     * @request PUT:/cs2/transport/{transportId}/event-filter/{eventFilterTransportId}
     * @secure
     * @response `200` `Cs2TransportVM`
     * @response `400` `BaseErrorResponse`
     */
    transportEventFilterControllerUpdateEventFilter = (
      transportId: number,
      eventFilterTransportId: number,
      data: UpdateTransportEventFilterReq,
      params: RequestParams = {},
    ) =>
      this.request<Cs2TransportVM, BaseErrorResponse>({
        path: `/cs2/transport/${transportId}/event-filter/${eventFilterTransportId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Transport
     * @name TransportEventFilterControllerDeleteEventFilter
     * @summary Deletes a transport event filter
     * @request DELETE:/cs2/transport/{transportId}/event-filter/{eventFilterTransportId}
     * @secure
     * @response `200` `Cs2TransportVM`
     * @response `400` `BaseErrorResponse`
     */
    transportEventFilterControllerDeleteEventFilter = (
      transportId: number,
      eventFilterTransportId: number,
      params: RequestParams = {},
    ) =>
      this.request<Cs2TransportVM, BaseErrorResponse>({
        path: `/cs2/transport/${transportId}/event-filter/${eventFilterTransportId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Transport
     * @name TransportControllerGetTransports
     * @summary Returns a list of transports
     * @request GET:/cs2/transport
     * @secure
     * @response `200` `(Cs2TransportVM)[]`
     * @response `400` `BaseErrorResponse`
     */
    transportControllerGetTransports = (
      query?: {
        /** @example 1 */
        transportClassId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Cs2TransportVM[], BaseErrorResponse>({
        path: '/cs2/transport',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Transport
     * @name TransportControllerCreateTransport
     * @summary Creates a transport
     * @request POST:/cs2/transport
     * @secure
     * @response `200` `Cs2TransportVM`
     * @response `400` `BaseErrorResponse`
     */
    transportControllerCreateTransport = (data: CreateTransportReq, params: RequestParams = {}) =>
      this.request<Cs2TransportVM, BaseErrorResponse>({
        path: '/cs2/transport',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Transport
     * @name TransportControllerUpdateTransport
     * @summary Updates a transport
     * @request PUT:/cs2/transport/{transportId}
     * @secure
     * @response `200` `Cs2TransportVM`
     * @response `400` `BaseErrorResponse`
     */
    transportControllerUpdateTransport = (transportId: number, data: UpdateTransportReq, params: RequestParams = {}) =>
      this.request<Cs2TransportVM, BaseErrorResponse>({
        path: `/cs2/transport/${transportId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Transport
     * @name TransportControllerDeleteTransport
     * @summary Deletes a transport
     * @request DELETE:/cs2/transport/{transportId}
     * @secure
     * @response `200` `Cs2TransportVM`
     * @response `400` `BaseErrorResponse`
     */
    transportControllerDeleteTransport = (transportId: number, params: RequestParams = {}) =>
      this.request<Cs2TransportVM, BaseErrorResponse>({
        path: `/cs2/transport/${transportId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new Transport();
}
